// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"200e045d","497":"8c38e654","568":"077b1df5"}[chunkId] + ".chunk.css";
};